import Viewer from './FileFieldsViewer';
import FileFieldsEditor from './FileFieldsEditor';

export const FileFieldsViewer = Viewer;
export default FileFieldsEditor;
